import { ApplicationInsights } from '@microsoft/applicationinsights-web';

// A second, dedicated Application Insights instance that carries ONLY the
// product-analytics events that previously went to Amplitude
// (Accept/Decline/RequestChanges/Pay/Documents/Downloads/etc.).
//
// It targets the AQ CPQ analytics resource (per-environment connection string
// from public/appsettings*.js) whose Log Analytics workspace feeds the
// blob -> Snowflake pipeline. The existing AppInsightsTelemetryService instance
// is intentionally left untouched and keeps sending page-view / route telemetry
// to its own resource.
let analyticsAppInsights = null;

const createAnalyticsTelemetry = () => {
  const initialize = connectionString => {
    if (!connectionString || analyticsAppInsights) {
      return;
    }

    analyticsAppInsights = new ApplicationInsights({
      config: {
        connectionString,
        // Custom events only. Auto-collection is disabled so this instance does
        // not duplicate the page-view / ajax / exception telemetry handled by
        // the primary instance, and cookies are disabled so the two instances
        // do not contend over the same session cookie.
        disableFetchTracking: true,
        disableAjaxTracking: true,
        disableExceptionTracking: true,
        enableAutoRouteTracking: false,
        disableCookiesUsage: true
      }
    });

    analyticsAppInsights.loadAppInsights();
    analyticsAppInsights.addTelemetryInitializer(envelope => {
      // eslint-disable-next-line no-param-reassign
      envelope.tags['ai.cloud.role'] = 'order_acceptance';
    });
  };

  return { initialize };
};

export const analyticsTelemetry = createAnalyticsTelemetry();
export const getAnalyticsAppInsights = () => analyticsAppInsights;
